import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { ClaimDocumentTypesPartialState } from './claim-document-types.reducer';
import { claimDocumentTypesQuery } from './claim-document-types.selectors';
import { LoadClaimDocumentTypes } from './claim-document-types.actions';

@Injectable({
  providedIn: 'root'
})
export class ClaimDocumentTypesFacade {
  loaded$ = this.store.pipe(select(claimDocumentTypesQuery.getLoaded));
  loading$ = this.store.pipe(select(claimDocumentTypesQuery.getLoading));
  error$ = this.store.pipe(select(claimDocumentTypesQuery.getError));
  allClaimDocumentTypes$ = this.store.pipe(
    select(claimDocumentTypesQuery.getAllClaimDocumentTypes)
  );
  selectedClaimDocumentType$ = this.store.pipe(
    select(claimDocumentTypesQuery.getSelectedClaimDocumentType)
  );
  selectedClaimDocumentTypes$ = this.store.pipe(
    select(claimDocumentTypesQuery.getSelectedClaimDocumentTypes)
  );

  constructor(private store: Store<ClaimDocumentTypesPartialState>) {}

  loadAll() {
    this.store.dispatch(new LoadClaimDocumentTypes());
  }
}
